import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { HelpText } from "../../App.styles";
import { FormAutocomplete, RowInfo } from "../../common";

const SectionText = styled(HelpText)`
  display: block;
  margin-bottom: 1rem;

  strong {
    color: ${({ theme }) => theme.black};
  }
`;

const OptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const OptionName = styled.div`
  color: ${({ theme }) => theme.black};
`;

const OptionDescription = styled.div`
  color: ${({ theme }) => theme.darkGreyColor}90;
  font-size: 0.875rem;
`;

const ChallengeTimingSection = ({ useQuery }) => {
  const { t } = useTranslation();

  const timingOptions = [
    {
      id: 0,
      name: t('Before the game'),
      description: t('Available before the game starts. Great for icebreakers, introductions, and prep activities.'),
    },
    {
      id: 1,
      name: t('During the game'),
      description: t('Available while the game is live. Use for the main challenges and activities.'),
    },
    {
      id: 2,
      name: t('After the game'),
      description: t('Available after the game ends. Great for reflections, feedback, and follow-ups.'),
    },
  ];

  return (
    <>
      <SectionText className="position-relative top-0 d-block" focus>
        <strong>{t('Choose when this challenge should be available to players.')}</strong>
        <br />
        {t('The timing determines when players can access and complete this challenge during the event.')}

        <p className="mt-4 mb-0">
          <strong>{t('Before the Game')}</strong>
          <br />
          {t('Available before the game starts. Use for kickoff tasks, preparation activities, introductions, or icebreakers that help players get ready before gameplay begins.')}
        </p>

        <p className="mt-4 mb-0">
          <strong>{t('During the Game')}</strong>
          <br />
          {t('Available while the game is in progress. Use for the main gameplay challenges and activities that players complete during the event.')}
        </p>

        <p className="mt-4 mb-0">
          <strong>{t('After the Game')}</strong>
          <br />
          {t('Available once the game ends. Use for wrap-up tasks, reflection prompts, feedback collection, celebrations, or post-event follow-up activities.')}
        </p>
      </SectionText>

      <RowInfo>
        <FormAutocomplete
          options={timingOptions}
          size="small"
          name="timing"
          useQuery={useQuery}
          renderOption={(option) => (
            <OptionWrapper>
              <OptionName>{option.name}</OptionName>
              <OptionDescription>{option.description}</OptionDescription>
            </OptionWrapper>
          )}
        />
      </RowInfo>
    </>
  );
};

export default ChallengeTimingSection;
